import { mq, backgroundGradient } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledErrorWrapper = styled.div.withConfig({ displayName: "StyledErrorWrapper", componentId: "sc-dc4z1h" }) `
  ${backgroundGradient}
  padding: calc(${(props) => props.theme.spacers.base * 38}px) 0 calc(${(props) => props.theme.spacers.base * 51}px);

  ${(props) => mq({
    paddingTop: [`calc(${props.theme.spacers.base * 19}px)`, `calc(${props.theme.spacers.base * 38}px)`],
    paddingBottom: [`calc(${props.theme.spacers.base * 25}px)`, `calc(${props.theme.spacers.base * 51}px)`],
})}
`;
